import { isInternalUser, UserInfo } from './auth';

type Gtag = (...args: unknown[]) => void;

// gtag.js が読み込めない（広告ブロッカー等）と event_callback は呼ばれないので、待つのはこの時間まで
const EVENT_CALLBACK_TIMEOUT_MS = 2000;

// プランへの申し込み・登録を GA4 に送る。直後に画面を離れても送信が落ちないよう、送信の完了まで
// 待つ Promise を返す（reject しない）。gtag は index.html が測定 ID を持つ build（stg・prd）でだけ
// 用意する。URL はクエリ（Stripe の session id 等）を落とし、参照元は origin だけにする。
// 社内ユーザーは traffic_type=internal を付け、GA4 の内部トラフィックのフィルタで除く。
export function trackSignUpEvent(
  name: 'begin_checkout' | 'sign_up',
  method: 'upgrade' | 'free',
  userInfo: UserInfo
): Promise<void> {
  const gtag = (window as { gtag?: Gtag }).gtag;
  if (!gtag) return Promise.resolve();
  return new Promise((resolve) => {
    setTimeout(resolve, EVENT_CALLBACK_TIMEOUT_MS);
    try {
      gtag('event', name, {
        method,
        ...(isInternalUser(userInfo) && { traffic_type: 'internal' }),
        page_location: location.origin + location.pathname,
        page_referrer: document.referrer ? new URL(document.referrer).origin : '',
        event_callback: resolve,
      });
    } catch {
      // 計測の失敗で申し込みの遷移を止めない
      resolve();
    }
  });
}
